import { render, staticRenderFns } from "./causePreventionTL.vue?vue&type=template&id=36c9ebc4"
import script from "./causePreventionTL.vue?vue&type=script&lang=js"
export * from "./causePreventionTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c9ebc4')) {
      api.createRecord('36c9ebc4', component.options)
    } else {
      api.reload('36c9ebc4', component.options)
    }
    module.hot.accept("./causePreventionTL.vue?vue&type=template&id=36c9ebc4", function () {
      api.rerender('36c9ebc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/timeline/causePreventionTL.vue"
export default component.exports